// extracted by mini-css-extract-plugin
export default {"logo":"MainPage_logo__JviO1"};